var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _g, _g2, _path59, _path60, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstitutionStudentTestEmpty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 679,
    height: 168,
    viewBox: "0 0 679 168",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9257_122614)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_9257_122614)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M518.146 59.5874L499.569 78.082L478.748 77.0386",
    stroke: "#4E68A6",
    strokeWidth: 7.51509,
    strokeLinecap: "square",
    strokeLinejoin: "bevel"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M621.373 29.5825H497.048V190.05H621.373V29.5825Z",
    fill: "#353954"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M610.503 39.8916H507.376V180.645H610.503V39.8916Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M595.3 84.4604H573.76V62.8882H595.3V84.4604ZM576.029 82.1879H593.035V65.1559H576.029V82.1879Z",
    fill: "#353954"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M563.937 65.1611H518.212V67.4337H563.937V65.1611Z",
    fill: "#767272"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M563.937 71.5977H518.212V73.8702H563.937V71.5977Z",
    fill: "#767272"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M544.552 78.0054H518.212V80.3017H544.552V78.0054Z",
    fill: "#767272"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M580.938 72.731L585.096 77.6524L602.859 62.8882",
    stroke: "#CE4D78",
    strokeWidth: 3.47495,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M595.3 120.516H573.76V98.9438H595.3V120.516ZM576.029 118.244H593.035V101.212H576.029V118.244Z",
    fill: "#353954"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M563.937 101.211H518.212V103.484H563.937V101.211Z",
    fill: "#767272"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M563.937 107.648H518.212V109.921H563.937V107.648Z",
    fill: "#767272"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M544.552 114.056H518.212V116.352H544.552V114.056Z",
    fill: "#767272"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M580.938 108.782L585.096 113.703L602.859 98.9438",
    stroke: "#CE4D78",
    strokeWidth: 3.47495,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M595.3 161.103H573.76V139.53H595.3V161.103ZM576.029 158.83H593.035V141.798H576.029V158.83Z",
    fill: "#353954"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M563.937 141.798H518.212V144.07H563.937V141.798Z",
    fill: "#767272"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M563.937 148.234H518.212V150.506H563.937V148.234Z",
    fill: "#767272"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M544.552 154.642H518.212V156.938H544.552V154.642Z",
    fill: "#767272"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M580.938 149.368L585.096 154.29L602.859 139.53",
    stroke: "#CE4D78",
    strokeWidth: 3.47495,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M586.894 26.7046H528.792V47.3716H586.894V26.7046Z",
    fill: "#4E68A6"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M528.792 47.3716V26.7046H586.894L528.792 47.3716Z",
    fill: "#124373"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M571.871 28.3531L544.947 27.7861L549.908 17H566.349L571.871 28.3531Z",
    fill: "#124373"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M561.102 24.9462C561.102 26.6709 559.708 28.0668 557.986 28.0668C556.264 28.0668 554.87 26.6709 554.87 24.9462C554.87 23.2216 556.264 21.8257 557.986 21.8257C559.708 21.8257 561.102 23.2216 561.102 24.9462Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M454.73 79.9873L446.562 101.912",
    stroke: "#4E68A6",
    strokeWidth: 7.51509,
    strokeLinecap: "square",
    strokeLinejoin: "bevel"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M467.312 123.184L470.252 182.089H477.359L482.83 113.856L468.292 113.694L467.312 123.184Z",
    fill: "#124373"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M471.56 118.929L452.608 182.417H445.254L455.548 112.383H470.904L471.56 118.929Z",
    fill: "#4E68A6"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M463.488 71.0829L469.791 70.0967L475.076 70.9066L476.436 75.8232L472.007 86.6856L464.168 83.7223L463.488 71.0829Z",
    fill: "#124373"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M471.76 99.2343L470.576 118.272L455.22 113.46L454.568 76.0566L460.282 73.4505L464.568 72.4644L471.76 99.2343Z",
    fill: "#124373"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M469.748 101.726L470.481 116.814L482.83 113.856L483.815 77.0381L480.546 72.293L474.172 71.8022L469.748 101.726Z",
    fill: "#124373"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M466.894 71.7979L463.768 72.8603L470.133 97.7436L474.79 72.7269L471.608 71.8074L466.894 71.7979Z",
    fill: "#CCCCCC"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M468.882 77.734L467.579 87.0813L470.019 96.6287L471.836 87.6721L469.791 77.6006L468.882 77.734Z",
    fill: "#E35B84"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M469.463 74.7368L467.679 77.4048L469.677 79.8393L471.327 77.4048L469.463 74.7368Z",
    fill: "#CE4D78"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M475.18 70.9067L472.673 83.9177L481.031 74.6371L475.18 70.9067Z",
    fill: "#4E68A6"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M466.361 83.6559L470.404 96.6288L469.748 101.726L460.448 83.1318L466.361 83.6559Z",
    fill: "#4E68A6"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M472.745 83.4504L468.168 105.051L479.381 82.3403L472.745 83.4504Z",
    fill: "#4E68A6"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M463.483 71.083L458.212 74.4179L466.494 84.1845L463.483 71.083Z",
    fill: "#4E68A6"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M469.462 74.7374L465.605 80.2686L463.768 72.8603L466.394 71.7979L469.462 74.7374Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M469.462 74.7372L472.017 71.7739L474.79 72.7268L473.297 80.6639L469.462 74.7372Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M471.794 74.48C471.794 74.48 470.39 76.4524 469.092 76.4238C467.793 76.3952 466.085 75.4519 465.809 74.1798C465.733 73.8225 465.728 73.4557 465.724 73.0889C465.695 70.378 465.666 67.6672 465.638 64.9516C465.643 65.5424 470.785 64.4704 471.051 64.6134C472.383 65.3185 471.784 74.4752 471.784 74.4752L471.794 74.48Z",
    fill: "#C28484"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M462.56 54.7799C461.59 54.0177 460.044 54.3607 459.259 55.3183C458.474 56.2759 458.364 57.648 458.688 58.8438C458.978 59.911 459.625 60.9257 460.614 61.4117C461.604 61.8976 462.945 61.7261 463.611 60.8447C462.941 58.8009 462.693 56.6141 462.884 54.4703",
    fill: "#C28484"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M475.033 54.1414C475.922 53.2838 477.497 53.4696 478.372 54.3367C479.248 55.2086 479.5 56.5664 479.3 57.786C479.124 58.877 478.582 59.9537 477.644 60.5397C476.712 61.1257 475.356 61.0923 474.605 60.2824C475.061 58.1766 475.09 55.9804 474.681 53.8698",
    fill: "#C28484"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M475.989 50.7639C472.678 51.1212 469.158 49.449 466.637 47.2432C465.642 49.8206 463.606 51.9407 461.009 52.6267C460.743 52.6982 460.833 60.2351 461.485 62.9078C462.336 66.3952 463.478 67.0479 465.719 68.3723C469.762 70.764 475.332 68.7439 476.503 63.9559C476.821 62.6553 476.988 50.6591 475.989 50.7687V50.7639Z",
    fill: "#DB9797"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M472.398 69.9634H465.657C463.064 69.9634 460.938 67.8385 460.938 65.2373C460.938 62.6408 460.072 60.5112 462.665 60.5112H475.152C477.744 60.5112 477.112 62.6361 477.112 65.2373C477.112 67.8338 474.99 69.9634 472.393 69.9634H472.398Z",
    fill: "#353954"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M470.461 64.2036C470.576 66.9097 467.498 66.3046 467.526 64.4466L470.461 64.2036Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M464.32 57.7337C465.519 58.6484 465.747 60.3635 464.834 61.5593C463.92 62.7599 462.208 62.9886 461.014 62.0739C459.815 61.1591 459.587 59.444 460.5 58.2482C461.414 57.0476 463.126 56.819 464.32 57.7337Z",
    fill: "url(#paint0_radial_9257_122614)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M476.551 57.6292C477.749 58.5439 477.978 60.259 477.064 61.4548C476.151 62.6554 474.438 62.8841 473.244 61.9694C472.05 61.0546 471.817 59.3395 472.731 58.1437C473.644 56.9431 475.357 56.7145 476.551 57.6292Z",
    fill: "url(#paint1_radial_9257_122614)"
  }), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M465.766 49.6676C467.208 50.7729 468.697 51.9068 470.447 52.407C472.921 53.1169 475.746 52.388 477.573 50.5776C479.4 48.7672 480.147 45.9373 479.462 43.4551C479.7 44.184 479.243 45.0607 478.51 45.2846C478.677 44.5604 478.463 43.7648 477.958 43.2169C477.987 43.8934 477.235 44.3841 476.565 44.3603C475.889 44.3365 475.285 43.9649 474.69 43.6409C473.934 43.2312 473.144 42.8834 472.326 42.6071C469.99 41.8258 467.407 41.6686 465.062 42.4308C457.208 44.9749 460.795 53.5933 460.814 60.8825C460.814 61.9878 461.257 62.5119 462.313 62.1736C461.961 60.1393 461.775 58.0764 461.761 56.0135C461.761 55.6372 462.484 54.5223 462.765 54.3699C464.406 53.4647 465.576 51.7543 465.828 49.8915C467.745 52.0211 470.723 53.1312 473.563 52.7786C476.403 52.4261 479.019 50.6157 480.356 48.0812C480.779 47.276 481.089 46.3565 480.941 45.4561C480.794 44.5557 480.094 43.6981 479.186 43.6219C478.896 43.9125 478.605 44.2079 478.315 44.4985C478.401 43.2836 477.554 42.0688 476.384 41.7257C475.218 41.3827 473.848 41.9496 473.268 43.0168C472.207 41.7591 470.352 41.6209 468.711 41.578C467.279 41.5399 465.776 41.5161 464.501 42.1688C463.226 42.8215 462.298 44.3937 462.855 45.7134C462.351 44.8367 461.033 44.5652 460.224 45.175C458.593 46.3994 458.531 52.8406 460.79 53.5886C462.798 54.2508 465.305 51.2636 465.761 49.6676H465.766Z",
    fill: "#353954"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M475.494 51.1833C476.351 53.8131 475.518 60.6354 476.403 63.2414C476.812 63.4272 477.093 62.8031 477.112 62.3553C477.245 59.1014 477.25 51.9646 476.784 48.7393",
    fill: "#353954"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M439.864 72.4597L501.782 168.344L518.94 156.238L457.113 62.0356L439.864 72.4597Z",
    fill: "#FFC846"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M448.356 67.5478L510.768 162.126L518.94 156.238L457.113 62.0356L448.356 67.5478Z",
    fill: "#E8B562"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M474.376 112.693C474.2 113.198 473.829 114.742 473.829 114.742C473.12 116.362 471.979 117.405 470.48 116.814L467.093 115.471C465.595 114.875 464.953 113.065 465.657 111.45L466.018 110.621C466.727 109.001 468.53 108.167 470.024 108.758L473.411 110.102C474.909 110.697 474.952 111.031 474.372 112.693H474.376Z",
    fill: "#DB9797"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M475.428 117.877C475.242 118.301 474.757 118.51 474.348 118.348L469.287 116.338C468.877 116.176 468.692 115.695 468.877 115.275C469.063 114.851 469.548 114.642 469.957 114.804L475.019 116.814C475.428 116.976 475.613 117.457 475.428 117.877Z",
    fill: "#DB9797"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M477.507 116.724C477.321 117.148 476.836 117.357 476.427 117.195L471.365 115.185C470.956 115.023 470.771 114.542 470.956 114.123C471.142 113.699 471.627 113.489 472.036 113.651L477.097 115.661C477.507 115.823 477.692 116.305 477.507 116.724Z",
    fill: "#DB9797"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M477.887 114.804C477.702 115.228 477.216 115.438 476.807 115.276L471.746 113.265C471.337 113.103 471.151 112.622 471.337 112.203C471.522 111.779 472.007 111.569 472.417 111.731L477.478 113.741C477.887 113.903 478.073 114.385 477.887 114.804Z",
    fill: "#DB9797"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M477.254 112.503C477.069 112.927 476.584 113.137 476.174 112.975L471.113 110.964C470.704 110.802 470.518 110.321 470.704 109.902C470.889 109.478 471.375 109.268 471.784 109.43L476.845 111.441C477.254 111.603 477.44 112.084 477.254 112.503Z",
    fill: "#DB9797"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M439.864 72.4597L457.113 62.0356L462.408 70.1681L445.092 80.9685L439.864 72.4597Z",
    fill: "white"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M439.864 72.4599L457.113 62.0358L455.615 59.3822C453.783 56.1377 449.649 55.0325 446.448 56.9286L440.349 60.5351C437.067 62.4789 436.087 66.7809 438.199 69.9587L439.859 72.4551L439.864 72.4599Z",
    fill: "#CE4D78"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M501.782 168.344L518.94 156.238L522.86 179.473L501.782 168.344Z",
    fill: "#EDEDED"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M467.189 116.476L469.515 117.334L472.826 109.111L468.659 108.005L467.189 116.476Z",
    fill: "white"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M446.562 102.402L465.509 110.749",
    stroke: "#4E68A6",
    strokeWidth: 7.51509,
    strokeLinecap: "square",
    strokeLinejoin: "bevel"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M468.963 109.301C468.963 109.854 468.516 110.306 467.959 110.306C467.403 110.306 466.956 109.859 466.956 109.301C466.956 108.744 467.403 108.296 467.959 108.296C468.516 108.296 468.963 108.744 468.963 109.301Z",
    fill: "#124373"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M325.865 35.9998L283.193 68.1123L327.022 126.352L369.693 94.2397L325.865 35.9998Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.452 59.1758L324.54 65.8831L317.822 56.957L326.735 50.2498L333.452 59.1758ZM324.771 64.2362L331.808 58.9406L326.504 51.8932L319.467 57.1888L324.771 64.2362Z",
    fill: "#353954"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.465 60.9563L295.546 75.1943L296.254 76.1346L315.173 61.8966L314.465 60.9563Z",
    fill: "#767272"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.47 63.6194L297.55 77.8574L298.258 78.7977L317.177 64.5597L316.47 63.6194Z",
    fill: "#767272"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.444 72.3065L299.545 80.5083L300.26 81.4585L311.159 73.2566L310.444 72.3065Z",
    fill: "#767272"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.857 58.7939L327.11 59.5356L329.863 47.8955",
    stroke: "#CE4D78",
    strokeWidth: 3.47495,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.679 74.0943L335.767 80.8015L329.05 71.8755L337.962 65.1683L344.679 74.0943ZM335.998 79.1546L343.035 73.8591L337.731 66.8117L330.695 72.1073L335.998 79.1546Z",
    fill: "#353954"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.691 75.8723L306.771 90.1104L307.479 91.0507L326.399 76.8127L325.691 75.8723Z",
    fill: "#767272"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.695 78.5359L308.776 92.7739L309.484 93.7142L328.403 79.4762L327.695 78.5359Z",
    fill: "#767272"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.67 87.2235L310.771 95.4253L311.486 96.3755L322.385 88.1736L321.67 87.2235Z",
    fill: "#767272"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.083 73.7113L338.336 74.4531L341.09 62.8149",
    stroke: "#CE4D78",
    strokeWidth: 3.47495,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.318 90.8882L348.405 97.5955L341.688 88.6694L350.6 81.9622L357.318 90.8882ZM348.636 95.9486L355.673 90.653L350.37 83.6056L343.333 88.9012L348.636 95.9486Z",
    fill: "#353954"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.329 92.6663L319.41 106.904L320.117 107.845L339.037 93.6066L338.329 92.6663Z",
    fill: "#767272"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.333 95.3289L321.414 109.567L322.121 110.507L341.041 96.2692L340.333 95.3289Z",
    fill: "#767272"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.721 90.5043L350.974 91.246L353.728 79.6079",
    stroke: "#CE4D78",
    strokeWidth: 3.47495,
    strokeMiterlimit: 10
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M229 0.364266L185.473 -11.2988L169.554 48.1093L213.082 59.7724L229 0.364266Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.543 17.4561L208.451 15.0201L210.891 5.91504L219.982 8.35106L217.543 17.4561ZM209.666 14.3176L216.844 16.2409L218.77 9.05214L211.592 7.12882L209.666 14.3176Z",
    fill: "#353954"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.488 5.76296L187.189 0.591797L186.932 1.55097L206.231 6.72213L206.488 5.76296Z",
    fill: "#767272"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.76 8.47976L186.461 3.30859L186.204 4.26776L205.503 9.43893L205.76 8.47976Z",
    fill: "#767272"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.853 8.99204L185.736 6.01318L185.476 6.9824L196.594 9.96126L196.853 8.99204Z",
    fill: "#767272"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.808 10.881L214.006 13.4283L223.173 9.20562",
    stroke: "#CE4D78",
    strokeWidth: 3.47495,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.465 32.6739L204.373 30.2379L206.813 21.1328L215.904 23.5688L213.465 32.6739ZM205.588 29.5353L212.766 31.4586L214.692 24.2699L207.514 22.3466L205.588 29.5353Z",
    fill: "#353954"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.411 20.9793L183.112 15.8081L182.855 16.7673L202.154 21.9384L202.411 20.9793Z",
    fill: "#767272"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.683 23.6961L182.384 18.5249L182.127 19.4841L201.426 24.6552L201.683 23.6961Z",
    fill: "#767272"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.776 24.2079L181.659 21.229L181.399 22.1982L192.516 25.1771L192.776 24.2079Z",
    fill: "#767272"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.731 26.0977L209.929 28.6451L219.095 24.4244",
    stroke: "#CE4D78",
    strokeWidth: 3.47495,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.875 49.8048L199.784 47.3687L202.223 38.2637L211.315 40.6997L208.875 49.8048ZM200.998 46.6662L208.176 48.5895L210.103 41.4008L202.925 39.4775L200.998 46.6662Z",
    fill: "#353954"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.821 38.1096L178.521 32.9385L178.264 33.8976L197.564 39.0688L197.821 38.1096Z",
    fill: "#767272"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.093 40.8264L177.794 35.6553L177.537 36.6144L196.836 41.7856L197.093 40.8264Z",
    fill: "#767272"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.141 43.2281L205.339 45.7755L214.505 41.5547",
    stroke: "#CE4D78",
    strokeWidth: 3.47495,
    strokeMiterlimit: 10
  }))), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M-22 179C-17.3478 177.137 108.726 133.811 109.657 96.5423C110.587 59.2733 71.0435 129.153 122.683 124.028C163.994 119.929 186.107 81.6346 192 63",
    stroke: "#16A34A",
    strokeWidth: 1.4,
    strokeDasharray: "6 6"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M327 188C347.912 179.906 383.464 156.375 358.369 127",
    stroke: "#16A34A",
    strokeWidth: 1.4,
    strokeDasharray: "6 6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_9257_122614",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(462.665 59.9025) rotate(-52.6817) scale(2.72837 2.72728)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#C47978",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2D3D3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_9257_122614",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(474.896 59.7961) rotate(-52.6816) scale(2.72837 2.72728)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#C47978",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2D3D3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9257_122614"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 679,
    height: 168,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_9257_122614"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 199,
    height: 151,
    fill: "white",
    transform: "translate(433 17)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstitutionStudentTestEmpty);
export default __webpack_public_path__ + "static/media/institution_student_test_empty.dd45f8b6ce4dbe79157516a6eee84fb4.svg";
export { ForwardRef as ReactComponent };